export default __webpack_public_path__ + "locales/pt-BR/ResetApplicationDialog.json?hash=596c425755461f0c752354608e0840a9";